module.exports = __webpack_public_path__ + "static/media/id-example.1e7b63dc.png";